module.exports = __webpack_public_path__ + "static/icon-d3aa9a118b7203db4b45e942d0249e1e.png";